export const GlobalActionTypes = {
    SetSnackBar: 'SetSnackBar',
}
export const LoginActionTypes = {
    loginInitiate: 'LoginInitiate',
    loginSuccess: 'LoginSuccess',
    loginFailed: 'LoginFailed',
}